<template>
  <main-content with_go_back_bar>
    <kt-panel>
      <kt-panel-body>
        <news-form :submit="createNews"></news-form>
      </kt-panel-body>
    </kt-panel>
  </main-content>
</template>

<script>
import $ from "jquery";
import { KTApp } from "@/plugins/core/app";
import { KTUtil } from "@/plugins/core/util";
import { newsService } from "@/common/api.service";
import newsForm from "./components/form";
import mainContent from "@/components/main-content";

export default {
  components: {
    newsForm,
    mainContent,
  },
  methods: {
    createNews(e, query) {
      let form = $(e.target);
      let btn = $("#submit_btn");

      form.validate({
        rules: {
          subject: {
            required: true,
          },
          newscontent: {
            required: true,
          },
        },
      });

      if (!form.valid()) {
        return;
      }

      KTApp.progress(btn);

      newsService
        .create(query)
        .then((response) => {
         
          this.$router.push("/news");
          this.showMsg(form, "success", response.data.message);
        })
        .catch(({ response }) => {
          if (response.data) {
            form.validate().showErrors(response.data.data);
          }
          this.showMsg(form, "danger", response.data.message);
        })
        .finally(() => {
          KTUtil.scrollTop();
          KTApp.unprogress(btn);
        });
    },
  },
};
</script>